import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";
import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import InteraktScript from "../../common/InteraktScript";
import { FaShoppingCart } from "react-icons/fa";
function PregaStart() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [userid, setUserid] = useState(0);
  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);
  const navigate = useNavigate();

  const tdStyle = {
    border: "1px solid #dee2e6",
    padding: "0.75rem",
    verticalAlign: "top",
  };

  return (
    <div className="new-home">
      <Header userid={userid} />

      <div className="banner-container position-relative round-back margin-top  ">
        <div className="container-fluid   py-5">
          <div className="row align-items-center ">
            <div className="col-md-6">
              <h1 className="hero-title text-red">
                💫 Just Got the Good News? Let's Confirm It Together
              </h1>
              <p className="under-subtitle py-4 text-gray-600">
                Welcome your pregnancy journey with confidence. Myprega’s
                PregaStart—Early Pregnancy Package offers an first In-clinic
                expert gynecologist consultation + first pregnancy sonography —
                all at half the market price and zero hassle.
              </p>
              <p
                style={{
                  fontSize: "28px",
                  fontWeight: "bolder",
                  color: "#d93e74",
                }}
              >
                Just at{" "}
                <span
                  style={{ textDecoration: "line-through", marginRight: "8px" }}
                >
                  ₹4000
                </span>
                ₹1599 (Limited Period Offer)
              </p>
              <Link to="/Confirm-Pregnancy-Form" className="round-btn btn-icon">
                <FaShoppingCart style={{ marginRight: "8px" }} />
                Book Now
              </Link>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/ConfirmationHero.png" alt="nt found"></img>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation1.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6 ">
              <h2 className="hero-title text-red">
                What is the PregaStart—Early Pregnancy Package?
              </h2>

              <p className="bold-font">
                Start your journey with assurance. Just got a positive result
                from your home pregnancy test? It’s time to take the next
                important step — a confirmation sonography (Dating Scan) and
                first consultation with a gynecologist.
              </p>
              <p className="bold-font" style={{ paddingTop: "10px" }}>
                With Myprega’s PregaStart—Early Pregnancy Package, we bring you:
              </p>
              <div style={{ marginTop: "18px" }}>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon green">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      First In-clinic Senior Gynecologist Consultation
                      (Obstetric expert)
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon blue">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      First Pregnancy Ultrasound (Sonography) —
                      Confirmation/Dating Scan
                    </h3>
                  </div>
                </div>
                <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                  <div className="benefit-icon orange">
                    <span className="icon">✔️</span>
                  </div>
                  <div className="benefit-content">
                    <h3 className="benefit-title">
                      Personalized scheduling at your preferred time and
                      convenience
                    </h3>
                  </div>
                </div>
              </div>
              <p className="bold-font">
                All of this comes together in one simple, seamless experience —
                managed entirely by Myprega.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                Why You Should Take This First Step With Myprega?
              </h2>
              <p className="bold-font" style={{ paddingBottom: "10px" }}>
                Because the first step sets the tone for your 9-month journey.
              </p>
              <ul className="searches-list">
                <li>
                  🩺 Medical Accuracy from Day 1:
                  <p className="benefit-text">
                    A proper obstretic confirmation scan confirms your pregnancy
                    and helps determine how far along you are.
                  </p>
                </li>
                <li>
                  󰟻 Talk to an OB-GYN, Not the Internet:
                  <p className="benefit-text">
                    {" "}
                    Ask all your early questions to an experienced gynecologist.
                  </p>
                </li>
                <li>
                  ⏱️ Avoid Long Waits:
                  <p className="benefit-text">
                    {" "}
                    No waiting at clinic and sonography centers, no multiple
                    calls to book sonography appointments. No double booking. We
                    manage everything.
                  </p>
                </li>
                <li>
                  💖 Get the Care You Deserve: We respect your time, your
                  emotions, and your comfort. All services are delivered with
                  love and empathy.
                  <p className="benefit-text">
                    We respect your time, your emotions, and your comfort. All
                    services are delivered with love and empathy.
                  </p>
                </li>
                <li>
                  {" "}
                  ❤️ Empathetic, expert support
                  <p className="benefit-text">
                    from pregnancy-focused doctors.
                  </p>
                </li>
              </ul>
              <p className="bold-font">
                And remember: this package is also your entry into a India’s
                first tech-driven, complete, comprehensive, prevention-focused,
                convenient, and affordable all-in-one 9-month care journey if
                you choose to continue with us.
              </p>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation2.png" className="w-100" alt="nt found" />
            </div>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#f8f9fa", padding: "3rem 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation3.png" className="w-100" alt="not found" />
            </div>
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                How Myprega is Different and Better
              </h2>

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #dee2e6",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #dee2e6",
                        padding: "0.75rem",
                        color: "#dc3545",
                        backgroundColor: "#f1f1f1",
                        textAlign: "left",
                      }}
                    >
                      Myprega
                    </th>
                    <th
                      style={{
                        border: "1px solid #dee2e6",
                        padding: "0.75rem",
                        color: "#dc3545",
                        backgroundColor: "#f1f1f1",
                        textAlign: "left",
                      }}
                    >
                      Typical Clinics/Hospitals
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={tdStyle}>Package at ₹1599</td>
                    <td style={tdStyle}>₹4000 – ₹5000</td>
                  </tr>
                  <tr>
                    <td style={tdStyle}>
                      Consultation + Scan scheduled and done by Myprega
                    </td>
                    <td style={tdStyle}>You book separately</td>
                  </tr>
                  <tr>
                    <td style={tdStyle}>No wait time – visit in your slot</td>
                    <td style={tdStyle}>Long wait times</td>
                  </tr>
                  <tr>
                    <td style={tdStyle}>
                      Empathetic, skilled, patient-centric doctors
                    </td>
                    <td style={tdStyle}>Varies widely in doctor quality</td>
                  </tr>
                  <tr>
                    <td style={tdStyle}>Pregnancy-focused platform</td>
                    <td style={tdStyle}>Generic healthcare approach</td>
                  </tr>
                  <tr>
                    <td style={tdStyle}>Easy upgrade to full care package</td>
                    <td style={tdStyle}>No continuity of care</td>
                  </tr>
                </tbody>
              </table>

              <p
                style={{
                  marginTop: "1rem",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                ✨ We care beyond the first visit. With us, you don’t just
                confirm your pregnancy — you start a compassionate, continuous
                care journey.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container  py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                Medical Expertise You Can Trust
              </h2>

              <p className="bold-font">
                Your care is in the hands of highly experienced, skilled,
                specifically trained, and empathetic medical professionals:
              </p>
              <div className="benefit-item" style={{ paddingTop: "20px" }}>
                <div className="benefit-icon green">
                  <span className="icon">✔️</span>
                </div>
                <div className="benefit-content">
                  <h3 className="benefit-title">
                    MBBS + MD Obstetrics & Gynecologists with more than 10 years
                    of experience
                  </h3>
                </div>
              </div>
              <div className="benefit-item" style={{ paddingBottom: "20px" }}>
                <div className="benefit-icon orange">
                  <span className="icon">✔️</span>
                </div>
                <div className="benefit-content">
                  <h3 className="benefit-title">
                    MD Radiologist, Obs. Sonography Specialist with more than 14
                    years of experience
                  </h3>
                </div>
              </div>
              <p className="bold-font">
                💬 “We believe in listening before treating. At Myprega, every
                woman’s journey is unique — and deeply respected.” – Team
                Myprega
              </p>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation4.png" className="w-100" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation5.png" className="w-100" alt="nt found" />
            </div>
            <div className="col-md-6">
              <h2 className="hero-title text-red">What Our Moms Say</h2>

              <div className="bold-font">
                <p>
                  "I just wanted to confirm my pregnancy but ended up choosing
                  Myprega for the full 9 months. They made me feel safe,
                  understood, and cared for from day one."
                </p>
                <div className="review-stars">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                </div>
                <p className="customer-name">— Sneha, Kharadi</p>
              </div>

              <br />

              <div className="bold-font" style={{ paddingBottom: "10px" }}>
                <p>
                  "Booking a consultation and scan used to feel like a chore.
                  With Myprega, No stress, no waiting. I felt taken care of the
                  moment I booked, and the doctor was amazing!"
                </p>
                <div className="review-stars">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                </div>
                <p className="customer-name">— Riya, Hinjewadi</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="hero-title text-red">Pricing & What You Get</h2>
              <p
                className="bold-font"
                style={{ paddingBottom: "10px", fontSize: "20px" }}
              >
                ✅ Package Includes:
              </p>
              <ul className="searches-list">
                <li>First In-clinic Senior Gynecologist Consultation</li>
                <li>First pregnancy Dating Sonography</li>
                <li>Personalized scheduling</li>
                <li>Emotional and medical support</li>
                <li>Option for upgrade to full pregnancy care</li>
              </ul>
              <br />

              <p className="bold-font">
                💰 Price: ₹1599 only (Flat 60% Off Market Price)<br></br>
                📍 Available across all Pune,<br></br>
                📆 Book at your convenient date & time | Limited slots per day
              </p>

              <Link
                to="/Confirm-Pregnancy-Form"
                className="round-btn btn-icon"
                style={{ textAlign: "center" }}
              >
                <FaShoppingCart style={{ marginRight: "8px" }} />
                🎉 Book Now{" "}
              </Link>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation6.png" className="w-100" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6 order-mobile">
              <img src="/Confirmation7.png" className="w-100" />
            </div>
            <div className="col-md-6">
              <h2 className="hero-title text-red">
                What Happens After You Book?
              </h2>
              <ul className="searches-list">
                <li> We’ll understand your preferred date and time</li>
                <li>
                  We schedules your gynec consultation and ultrasound with our
                  highly skilled doctors — we handle everything.
                </li>
                <li>
                  Our team reminds you, supports you, and stays with you
                  throughout.
                </li>
                <li>
                  After completion, you get an exclusive upgrade option to our
                  full pregnancy cherish care package at discounted rates with
                  special benefits.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <br />
      <div className="footer-message" style={{ textAlign: "center" }}>
        <p>
          💡 This isn’t just a consultation and scan — it’s the beginning of a
          new chapter.
          <br />
          💜 Don’t let early doubts or endless clinic bookings cloud your first
          steps. Let Myprega bring clarity, care, and convenience right to you.
        </p>
        {/* <br/> */}
        <p>
          Choose compassion over confusion, expertise over endless searches, and
          Myprega over the usual.
        </p>
        <p className="text-red">
          {" "}
          👉 Book Your PregaStart—Early Pregnancy Package Today
        </p>
        <br />
        <Link to="/Confirm-Pregnancy-Form" className="cta-button">
          <span style={{ textDecoration: "line-through", marginRight: "8px" }}>
            ₹4000
          </span>
          ₹1599 Only – Limited-Time Offer
        </Link>
      </div>
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default PregaStart;
